import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

/** A framed placeholder filling the result area until there is something to chart. */
export const EmptyStateRoot = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(3),
  margin: theme.spacing(2),
  padding: theme.spacing(4),
  border: `1px solid ${theme.palette.divider}`,
  // Twice the theme radius, as `borderRadius: 2` means in sx.
  borderRadius:
    typeof theme.shape.borderRadius === 'number'
      ? theme.shape.borderRadius * 2
      : `calc(2 * ${theme.shape.borderRadius})`,
}));
